import { ActionTypes } from "./types";
import { newDate } from "helpers/dateTools";

const {
    GET_ISSUES,
    RESTORE_INITIAL,
    SET_ISSUES_FILTERS,
    SET_EDIT_ISSUE,
    NEW_ISSUE,
    SET_ASSIGN_ISSUE,
    UPDATE_ISSUE
} = ActionTypes

const serviceTypes = [
    { id: "LEAK", text: "FUGA" },
    { id: "COMPLAINT", text: "QUEJA" },
    { id: "SERVICE", text: "SERVICIO" },
    { id: "OTHER", text: "OTRO" }
]

const statuses = [
    { id: "ACTIVE", text: "ACTIVO" },
    { id: "ASSIGNED", text: "ASIGNADO" },
    { id: "RESOLVED", text: "RESUELTO" },
    { id: "CANCELED", text: "CANCELADO" }
]

const INITIAL_STATE = {
    issues: [],
    selectedIssue: {},
    startDate: newDate(),
    endDate: newDate(),
    station: [],
    config: {
        page: 0,
        pageSize: 20,
        filtered: [],
        sorted: []
    },
}

const parsePayload = (payload) => {
    return {
        issueId: payload.id,
        idStation: payload.customer?.account.station.id,
        idUnit: payload.unit?.id,
        service: payload.service,
        code: payload.customer?.account?.code,
        idAccount: payload.customer?.account?.id,
        serviceType: payload.serviceType,
        status: payload.status,
        technician: payload.technician,
        observations: payload.observations
    }
}

export const issuesReducer = (state = INITIAL_STATE, { type, payload }) => {
    switch (type) {
        case GET_ISSUES:
            return {
                ...state,
                ...payload,
            };
        case RESTORE_INITIAL:
            return INITIAL_STATE

        case SET_ISSUES_FILTERS:
            return {
                ...state,
                [payload.key]: payload.data,
            }
        case SET_EDIT_ISSUE:
            return {
                ...state,
                selectedIssue: parsePayload(payload)
            }
        case SET_ASSIGN_ISSUE:
            return {
                ...state,
                selectedIssue: parsePayload(payload)
            }
        case UPDATE_ISSUE:
            return {
                ...state,
                issues: state.issues.map(obj => {
                    if (obj.id === payload.id) {
                        return {
                            ...payload,
                            stationName: payload.customer?.account?.station?.name,
                            accountCode: payload.customer?.account?.code,
                            unitNumber: payload.unit?.number,
                            serviceTypeName: serviceTypes.find(x => x.id === payload.serviceType)?.text || 'DESCONOCIDO',
                            statusName: statuses.find(x => x.id === payload.status)?.text || 'DESCONOCIDO'
                        }
                    }
                    return obj
                })
            }
        case NEW_ISSUE:
            return {
                ...state,
                issues: [payload, ...state.issues]
            }
        default:
            return state;
    }
}